import React, {useState, useContext, useEffect, useRef } from 'react';
import { IonCard, IonInput, IonText, IonLabel, IonSlides, IonSlide, IonImg, IonModal, IonGrid, IonRow, IonCol, IonButton, IonCardContent, IonContent, IonHeader, IonFooter, IonToolbar, IonPopover, IonSegment, IonSegmentButton } from '@ionic/react';

//import { Bluefin_Hotel_context } from '../../../storeState/bluefin_hotel_context';
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../../css/layout.css'
//import { GetGuestSearchMatch } from './GetGuestSearchMatch';
//import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { PayModal_Retail } from './Modal_Pay_locals_Retail';
import {Registration_GeoLocation } from './Registration_GeoLocation'

import { Preferences } from '@capacitor/preferences'

function addStorage_cart(event) {

    //alert(event);

    Preferences.set({
        key: 'cartList',
        value: JSON.stringify(event),
        //value: [event[0], event[1], event[2], event[3],  event[4]].toString(),

    })
}

export function Modal_Checkout_Retail (props) {

    //let authenticatedMerchent_context = useContext(Auth_MerchantID_context);
    let authMerchant_objects = useContext(Auth_MerchantID_context);

    const [companyID, setCompanyID ] = useState(props.data.companyId);

    const [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    const [cartList, setCartList] = useState(authMerchant_objects.cartList);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);
    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);


    let [checkInNonMemberPaymentType, setCheckInNonMemberPaymentType ] = useState('mm');
    let [checkInCustomerStatus, setCheckInCustomerStatus ] = useState('member');
    let [checkInAttachment_ID, setCheckInAttachment_ID ] = useState(null);

    let [ccInfoDisplay, setCCInfoDisplay ] = useState('none');
    let [mmInfoDisplay, setMMInfoDisplay ] = useState('none');
    let [checkingInfoDisplay, setCheckingInfoDisplay ] = useState('none');
    let [cashInfoDisplay, setCashInfoDisplay ] = useState('inline-block');


    let [cartSubtotal, setCartSubTotal] = useState(null);
    let [cartCheckoutTotal, setCartCheckoutTotal] = useState(null);
    let [cartArrayList, setCartArrayList] = useState([]);
    let [storefront, setStoreFront] = useState('ONLINE');

    let [cartLatitude, setCartLatitude] = useState(null);
    let [cartLongitude, setCartLongitude] = useState(null);

    let [ openPayModal, setOpenPayModal] = useState(false);

    let [viewIonPopover, setvViewIonPopover] = useState(false);

    let [mobileNumber, setMobileNumber] = useState('');
    let [errorMessage, setErrorMessage] = useState('');

    let [enterFirstName, setEnterFirstName] = useState('');
    let [enterLastName, setEnterLastName] = useState('');

    let [deliveryProductID, setDeliveryProductID] = useState('');
    let [deliveryProductName, setDeliveryProductName] = useState('');
    let [deliveryFee, setDeliveryFee] = useState('');
    let [deliveryProductQuantity, setDeliveryProductQuantity] = useState('');

    let [viewDeliveryFee, setViewDeliveryFee] = useState(false);

    //let selectCheckInDateRef = useRef();
    //let selectCheckOutDateRef = useRef();


    let enterQavaNumberRef = useRef(null);

    let enterMemberPaymentAmountRef = useRef();
    let enterFirstNameRef = useRef();
    let enterLastNameRef = useRef();
    let enterMobileNumberRef = useRef();
    let enterEmailRef = useRef();

    let enterID_numberRef = useRef('00000');
    
    let enterCC_numberRef = useRef();
    let enterCC_expDateRef = useRef();
    let enterCC_cvvNumberRef = useRef();
    let enterCC_addressRef = useRef();
    let enterCC_cityRef= useRef();
    let enterCC_stateRef = useRef();
    let enterCC_zipRef = useRef();
    let enterCC_nonMember_amountRef = useRef();

    let enterMM_displayRef = useRef();
    let selectMobileMoneyProviderRef = useRef();
    let enterMM_phoneNumberRef = useRef();
    let enterMM_nonMember_amountRef = useRef();


    let enterChecking_displayRef = useRef();
    let enterChecking_bankNameRef = useRef();
    let enterChecking_accountNumberRef = useRef();
    let enterChecking_routingNumberRef = useRef();
    let enterChecking_nonMember_amountRef = useRef();

    let enterCash_displayRef = useRef();
    let enterCash_amountRef = useRef();


function handleMobileNumberChange(e) {

    const input = e.detail.value || '';
    if (!input.startsWith('0')) {
        setErrorMessage('Mobile number must start with 0.');
    } else {
        setErrorMessage('');
    }
    setMobileNumber(input);
    //enterMobileNumberRef.current = input;
};


function handleEnterAttachement() {  


    fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
    .then(res => res.blob())
    .then(data => {

        //alert(JSON.stringify(data));

        const blobUrl = URL.createObjectURL(data);

        let noImageFile = new File([data], blobUrl, {
            enctype: 'multipart/form-data',
            type: 'image/jpeg',
            name: 'xImageFile',
            accept: "image/*",
        });
        
        setCheckInAttachment_ID(noImageFile);

        //alert("No Attachment Option checked");

    })
}

function confirmCheckout(event)
{
    setOpenPayModal(false);

    //alert(checkInRoomID);
    //alert(roomSalePrice);

    if(cartList.size != 0)
    {

        //e.preventDefault();

        
        let formData = new FormData();
        //formData.append('user', acctID);
        //formData.append('sessionID', sessionID);
        //formData.append('xImageFile', checkInAttachment_ID);

        let activeAcctID;

        if(acctID == null)
        {
            activeAcctID = event[3];
        }
        else if(acctID != null)
        {
            activeAcctID = acctID;
        }

        let headers = new Headers();

        const requestOptions = {
            method: 'POST',
            //mode: 'no-cors',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
            //headers: headers.append('Access-Control-Allow-Origin', 'https://bluefinhoteltest.com'), 
            //headers: headers.append('content-type', 'application/json'), 
            body: JSON.stringify({
                Tracker: '74706_confirmCheckout_retail_public',
                user: activeAcctID,
                xCompanyID_public: props.data.companyId,
                xCartList:  JSON.stringify(cartList),
                xCartFirstName: enterFirstName.replace(/\s+/g, '_'),
                xCartLastName: enterLastName.replace(/\s+/g, '_'),
                xCartMobileNumber: mobileNumber,
                //xCartEmail: enterEmailRef.current.value.replace(/\s+/g, ''),
                xCartSubtotal: cartSubtotal,
                xCartCheckoutTotal: cartCheckoutTotal,
                xCartLatitude: cartLatitude,
                xCartLongitude: cartLongitude,
                //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,    
                xCartNonMemberPaymentType: checkInNonMemberPaymentType,
                xUserStatus: checkInCustomerStatus,
                xOrderID: event[1],
                xOrderID_customer: event[2],
                xOrderID_payStatus: event[0],
                xStorefront: storefront,
                sessionID: sessionID,

            }),
        }

        //alert('Inside GetAvaialbleRoom AFTER upload');
        //alert(baseURL);

        let newBaseURL = 'https://ghanaverified.com';
        if(baseURL == 'https://bluefinhoteltest.com/' || baseURL == 'https://bluefinhoteltest.com/overviewTab')
        {
            newBaseURL = 'https://ghanaverifiedtest.com'
        }

        fetch(baseURL+'ghanaverified_retail/', requestOptions)
        //fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {
            
            alert("CHECKOUT COMPLETE.  PLEASE VIEW ORDER/INVOICE IN YOUr ACCOUNT. INVOICE ID IS - "+event[4])

            window.location.href = '/';
    
        })

        props.closeModal(false);

    }
    


    else
    {
        //e.preventDefault();

        alert('Please Add Items to Cart');

    }

}

function retrieveCurrentGeolocation(event) 
{
    //alert("in get current registration coordinates");
    // alert(event);
    // alert(event[0]);
    // alert(event[1]);

    setCartLatitude(event[0]);
    setCartLongitude(event[1]);
}

function confirmCheckoutHandler(e)
{
    e.preventDefault();

    setOpenPayModal(true);

    //confirmGuestBooking(e);
}


function handlePopover() {

    setOpenPayModal(false);

    props.closeModal(false);
}    


useEffect(() => {

    //  alert("IN USE EFFECT");
    //  alert(acctID);
    //  alert(cartList);
    //  alert(cartList.length);
     //alert(JSON.parse(cartList[0]));
     //alert(JSON.parse(cartList[0]).price);

    let cartSubtotal = 0;

    for (let rownum = 0; rownum < cartList.length; ++rownum)
    {
        //alert("IN SUBTOTAL");

        let cartItems = cartList[rownum];

        // alert(cartItems.price);
        // alert(cartItems.quantity);

        cartSubtotal += cartItems.price * cartItems.quantity;

        //alert(cartSubtotal);


    }
    

    //let cartCheckoutTotal = cartSubtotal + (cartSubtotal * .15); //PLUS TAX
    let cartCheckoutTotal = cartSubtotal + (cartSubtotal * 0);

    setCartSubTotal(cartSubtotal);
    setCartCheckoutTotal(cartCheckoutTotal);


    //const wrappedArrayString = `[${cartList}]`;

    //const cartArray = JSON.parse(wrappedArrayString);

    //setCartArrayList(wrappedArrayString);

    // alert("TOTAL CALCULATED");
    // alert(cartSubtotal);
    // alert(cartCheckoutTotal);

    
}, [])

useEffect(() => {

    // alert("IN USE EFFECT ACCTID");
    // alert(acctID);

    if(acctID != null && props.data.status != "create_order_internal")
    {

        setEnterFirstName(authMerchant_objects.employeeFirstName );
        //alert(authMerchant_objects.employeeFirstName );

        setEnterLastName(authMerchant_objects.employeeLastName );
        //alert(authMerchant_objects.employeeLastName );

        setMobileNumber(authMerchant_objects.companyPhoneNumber );
        //alert(authMerchant_objects.companyPhoneNumber );


    }
    if(props.data.status == "create_order_internal")
    {
        setCheckInNonMemberPaymentType("CASH");
        setStoreFront("IN_STORE");
        setCheckInCustomerStatus('non_member');

    }

}, [])


async function deleteCartItem(index){


    //alert('IN DELETE CART ITEM');

    const updatedCartArrayList = cartList.filter((_, i) => i !== index);

    setCartList(updatedCartArrayList);

    await addStorage_cart(updatedCartArrayList);

    authMerchant_objects.changeCartList(updatedCartArrayList);


    let cartSubtotal = 0;

    for (let rownum = 0; rownum < updatedCartArrayList.length; ++rownum)
    {

        let cartItems = updatedCartArrayList[rownum];

        cartSubtotal += cartItems.price * cartItems.quantity;

    }
    

    //let cartCheckoutTotal = cartSubtotal + (cartSubtotal * .15); //PLUS TAX
    let cartCheckoutTotal = cartSubtotal + (cartSubtotal * 0);

    setCartSubTotal(cartSubtotal);
    setCartCheckoutTotal(cartCheckoutTotal);

  };


function addToCartHandler(event) {
    let cartItems = {
        id: event[1],
        name: event[2],
        price: event[3],
        quantity: event[4],
    };

    setCartList(function (prevCartList) {
        let updatedCartList = [...prevCartList, cartItems];

        addStorage_cart(updatedCartList);
        authMerchant_objects.changeCartList(updatedCartList);

        let cartSubtotal = 0;

        for (let rownum = 0; rownum < updatedCartList.length; ++rownum) {
            let item = updatedCartList[rownum];
            cartSubtotal += item.price * item.quantity;
        }

        let cartCheckoutTotal = cartSubtotal + (cartSubtotal * 0);

        setCartSubTotal(cartSubtotal);
        setCartCheckoutTotal(cartCheckoutTotal);

        return updatedCartList;
    });
}

function getDeliveryFee()
{


            const requestOptions = {
                method:'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    },
                body: JSON.stringify({
                    Tracker: "33_delivery_fee_checkout",
                    //user: acctID,
                    user: props.data.companyId,
                    xCustomerAccountID: acctID,
                    sessionID: sessionID,

                })            }
    
            //alert('In ghanaverifiedApp - HotelList UseEffect');

            fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                    let cols = rows[0].split('|');
                    
                    let productID = cols[0];
                    let productName = cols[1];
                    let publicePrice = cols[2];
                    let productQuantity = 1;

                    setDeliveryProductID(productID);
                    setDeliveryProductName(productName);
                    setDeliveryFee(publicePrice);
                    setDeliveryProductQuantity(productQuantity);

                    //addToCartHandler([true, productID, productName, publicePrice, productQuantity])

                //props.confirmComplete();
                //setSaveDisabled(false);
            })
}

function setViewDeliveryFeeHandler()
{

    addToCartHandler([true, deliveryProductID, deliveryProductName, deliveryFee, deliveryProductQuantity]);
    setViewDeliveryFee(true);
}

function pickUpOnlyHandler() 
{
    setViewDeliveryFee(false);
    deleteCartItem(cartList.length - 1);
}

function closeModalHandler() {

        //alert("IN CLOSE MODAL");
        //alert(viewDeliveryFee);

    
    if(viewDeliveryFee == true)
    {
        alert("IN CLOSE MODAL 2");
        deleteCartItem(cartList.length - 1);
    }
    setOpenPayModal(false);
    props.closeModal(false);
}  


useEffect(() => {

    if(acctID != null)
    {
        getDeliveryFee(authMerchant_objects.authenticated, acctID);
    }

}, [])
//alert('Inside RETAIL CHECKOUT');
// alert(acctID);
//alert(props.data.mtnCompanyPhoneNumber);

return (
    <React.Fragment>
        {props.openModal == true ?
            (
        <IonModal isOpen={ props.openModal }>
            <form onSubmit={confirmCheckoutHandler}>
            <IonHeader  style={{ color: "black" }}>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonText>CHECKOUT</IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonButton onClick={() => setvViewIonPopover(true)}>View Cart</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
         
        </IonHeader>
                
            <IonContent className='grid_content'>

            {viewIonPopover && (

                <div
                onClick={() => setvViewIonPopover(false)} // Close on backdrop click
                style={{
                position: 'absolute',
                width: '75%',
                height: '85%',
                backgroundColor: 'white',
                transform: 'translate(10%, 0%)',
                padding: '16px',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                zIndex: 1000,
                borderRadius: '8px',       /* Rounded corners */
                border: '2px rgb(0, 0, 0) solid',
                }}
                >

                <IonGrid className='popOver'>
                    <IonRow >
                            <IonCol size='3'>Name</IonCol>
                            <IonCol size='3'>Price</IonCol>
                            <IonCol size='3'>Quantiy</IonCol>
                            <IonCol size='3'>Action</IonCol>
                        </IonRow>

                    {cartList.map((detailData, index) =>   {
                    return (
                        <IonRow key={detailData.id || index}>
                            <IonCol size='3'>{detailData.name || "N/A"}</IonCol>
                            <IonCol size='3'>{detailData.price || "N/A"}</IonCol>
                            <IonCol size='3'>{detailData.quantity || "N/A"}</IonCol>
                            <IonCol size='3'><IonButton className='small_button' onClick={() => deleteCartItem(index)}>Remove</IonButton></IonCol>
                        </IonRow>
                            )
                        }
                    )}
                </IonGrid>
                <IonButton onClick={() => setvViewIonPopover(false)}>close</IonButton>
                </div>
                )}   
         {props.data.status != "create_order_internal" &&

                <IonGrid >
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel htmlFor="paymenttype">STOREFRONT </IonLabel>                                    
                        </IonCol>
                        <IonCol className='ionCol_inputContent'  size='6'>
                            <select name="paymenttype" id='paymenttype' onChange={(e) => setStoreFront(e.target.value) }>
                                {/*<option value='cc'>Credit Card</option>*/}
                                <option value='ONLINE' selected='selected'>ONLINE</option>
                                {/*<option value='checking'>Checking</option>*/}
                                <option value='IN_STORE'>IN STORE</option>*
                            </select>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel htmlFor="paymenttype">Payment Type </IonLabel>                                    
                        </IonCol>
                        <IonCol className='ionCol_inputContent'  size='6'>
                            <select name="paymenttype" id='paymenttype' onChange={(e) => setCheckInNonMemberPaymentType(e.target.value) }>
                                {/*<option value='cc'>Credit Card</option>*/}
                                <option value='mm' selected='selected'>Mobile Money</option>
                                {/*<option value='checking'>Checking</option>*/}
                                <option value='CASH'>Cash</option>*
                            </select>
                        </IonCol>
                    </IonRow>
                    
                    {acctID == null &&<IonRow>
                        <IonCol size='6'>
                            <IonLabel>First Name: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput type='text' placeholder='Enter' value={enterFirstName }  autocomplete='off' onIonChange={(e) => setEnterFirstName(e.target.value)} required></IonInput>
                        </IonCol>
                    </IonRow>}
                    {acctID == null && <IonRow>
                        <IonCol size='6'>
                            <IonLabel>Last Name: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput type='text' placeholder='Enter' value={enterLastName }  autocomplete='off' onIonChange={(e) => setEnterLastName(e.target.value)} required></IonInput>
                        </IonCol>
                    </IonRow>}
                    {acctID != null && <IonRow>
                        <IonCol size='6'>
                            <IonLabel>First Name: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput type='text' placeholder='Enter' value={authMerchant_objects.employeeFirstName } required></IonInput>
                        </IonCol>
                    </IonRow>}
                    {acctID != null && <IonRow>
                        <IonCol size='6'>
                            <IonLabel>Last Name: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput type='text' placeholder='Enter' value={authMerchant_objects.employeeLastName } required></IonInput>
                        </IonCol>
                    </IonRow>}
                    <IonRow>
                        {/*<IonCol size='6'>
                            <IonLabel>Mobile Number: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput placeholder='Enter' ref={enterMobileNumberRef} required></IonInput>
                        </IonCol>*/}
                        <IonCol size="6">
                            <label htmlFor="searchSupplierName">Mobile Number:</label>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size="6">
                            <IonInput
                                id="searchSupplierName"
                                placeholder="Enter mobile number"
                                type="tel"
                                value={mobileNumber}
                                onIonChange={(e) => handleMobileNumberChange(e)}
                                required/>
                            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size='6'>
                            <IonLabel>Payment Amount: </IonLabel>
                        </IonCol>
                        <IonCol className='ionCol_inputContent' size='6'>
                            <IonInput placeholder='Enter' ref={enterMM_nonMember_amountRef} required></IonInput>
                        </IonCol>
                    </IonRow>
                    {/*<IonRow>
                        <IonCol size='6'>
                            <IonButton onClick={() => setViewDeliveryFee(true)}> Delivery</IonButton>
                        </IonCol>
                        <IonCol size='6'>
                            <IonButton onClick={() => pickUpOnlyHandler([true, deliveryProductID])}> Pickup </IonButton>
                        </IonCol>
                    </IonRow>*/}
                    <IonRow>
                    <IonCol size="12">
                        <IonSegment value={viewDeliveryFee ? "delivery" : "pickup"}>
                        
                        <IonSegmentButton
                            value="delivery"
                            onClick={setViewDeliveryFeeHandler}
                            disabled={viewDeliveryFee}

                        >
                            <IonLabel>Delivery</IonLabel>
                        </IonSegmentButton>

                        <IonSegmentButton
                            value="pickup"
                            onClick={pickUpOnlyHandler}
                            disabled={!viewDeliveryFee}
                        >
                            <IonLabel>Pickup</IonLabel>
                        </IonSegmentButton>

                        </IonSegment>
                    </IonCol>
                    </IonRow>
                    <IonRow >
                        <IonCol size='6'>
                            <IonLabel>SubTotal: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            {cartSubtotal}
                        </IonCol>
                    </IonRow>
                    {viewDeliveryFee == true && <IonRow >
                        <IonCol size='6'>
                            <IonLabel>Delivery Fee: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            {deliveryFee}
                        </IonCol>
                    </IonRow>}
                    <IonRow >
                        <IonCol size='6'>
                            <IonLabel>Total: </IonLabel>
                        </IonCol>
                        <IonCol size='6'>
                            {cartCheckoutTotal}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            }


            {props.data.status == "create_order_internal" &&

            <IonGrid >
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel htmlFor="paymenttype">STOREFRONT </IonLabel>                                    
                    </IonCol>
                    <IonCol className='ionCol_inputContent'  size='6'>
                        <select name="paymenttype" id='paymenttype' onChange={(e) => setStoreFront(e.target.value) }>
                            {/*<option value='cc'>Credit Card</option>*/}
                            <option value='ONLINE'>ONLINE</option>
                            {/*<option value='checking'>Checking</option>*/}
                            <option value='IN_STORE' selected='selected'>IN STORE</option>*
                        </select>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel htmlFor="paymenttype">Payment Type </IonLabel>                                    
                    </IonCol>
                    <IonCol className='ionCol_inputContent'  size='6'>
                        <select name="paymenttype" id='paymenttype' onChange={(e) => setCheckInNonMemberPaymentType(e.target.value) }>
                            {/*<option value='cc'>Credit Card</option>*/}
                            <option value='mm'>Mobile Money</option>
                            {/*<option value='checking'>Checking</option>*/}
                            <option value='CASH' selected='selected'>Cash</option>*
                        </select>
                    </IonCol>
                </IonRow>
                
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel>Customer First Name: </IonLabel>
                    </IonCol>
                    <IonCol className='ionCol_inputContent' size='6'>
                        <IonInput type='text' placeholder='Enter' value={enterFirstName }  autocomplete='off' onIonChange={(e) => setEnterFirstName(e.target.value)} required></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel>Customer Last Name: </IonLabel>
                    </IonCol>
                    <IonCol className='ionCol_inputContent' size='6'>
                        <IonInput type='text' placeholder='Enter' value={enterLastName }  autocomplete='off' onIonChange={(e) => setEnterLastName(e.target.value)} required></IonInput>
                    </IonCol>
                </IonRow>
                <IonRow>
                    {/*<IonCol size='6'>
                        <IonLabel>Mobile Number: </IonLabel>
                    </IonCol>
                    <IonCol className='ionCol_inputContent' size='6'>
                        <IonInput placeholder='Enter' ref={enterMobileNumberRef} required></IonInput>
                    </IonCol>*/}
                    <IonCol size="6">
                        <label htmlFor="searchSupplierName">Mobile Number:</label>
                    </IonCol>
                    <IonCol className='ionCol_inputContent' size="6">
                        <IonInput
                            id="searchSupplierName"
                            placeholder="Enter mobile number"
                            type="tel"
                            value={mobileNumber}
                            onIonChange={(e) => handleMobileNumberChange(e)}
                            required/>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='6'>
                        <IonLabel>Payment Amount: </IonLabel>
                    </IonCol>
                    <IonCol className='ionCol_inputContent' size='6'>
                        <IonInput placeholder='Enter' ref={enterMM_nonMember_amountRef} required></IonInput>
                    </IonCol>
                </IonRow>
                {/*<IonRow>
                    <IonCol size='6'>
                    <IonButton onClick={() => setViewDeliveryFeeHandler()}> Delivery</IonButton>
                    </IonCol>
                    <IonCol size='6'>
                    <IonButton onClick={() => pickUpOnlyHandler()}> Pickup </IonButton>
                    </IonCol>
                </IonRow>*/}
                <IonRow>
                <IonCol size="12">
                    <IonSegment value={viewDeliveryFee ? "delivery" : "pickup"}>
                    
                    <IonSegmentButton
                        value="delivery"
                        onClick={setViewDeliveryFeeHandler}
                        disabled={viewDeliveryFee}

                    >
                        <IonLabel>Delivery</IonLabel>
                    </IonSegmentButton>

                    <IonSegmentButton
                        value="pickup"
                        onClick={pickUpOnlyHandler}
                        disabled={viewDeliveryFee}

                    >
                        <IonLabel>Pickup</IonLabel>
                    </IonSegmentButton>

                    </IonSegment>
                </IonCol>
                </IonRow>
                <IonRow >
                    <IonCol size='6'>
                        <IonLabel>SubTotal: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        {cartSubtotal}
                    </IonCol>
                </IonRow>
                {viewDeliveryFee == true && <IonRow >
                    <IonCol size='6'>
                        <IonLabel>Delivery Fee: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        {deliveryFee}
                    </IonCol>
                </IonRow>}
                <IonRow >
                    <IonCol size='6'>
                        <IonLabel>Total: </IonLabel>
                    </IonCol>
                    <IonCol size='6'>
                        {cartCheckoutTotal}
                    </IonCol>
                </IonRow>
            </IonGrid>
            }
                <Registration_GeoLocation gps_location={retrieveCurrentGeolocation} ></Registration_GeoLocation>

            </IonContent>

            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonButton type='submit' className='grid_checkInFooter_left' > Confirm Purchase </IonButton>
                        </IonCol>
                        <IonCol>
                            <IonButton onClick={() => closeModalHandler()} className='grid_checkInFooter_right'> Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
            </form>

            </IonModal>
            ) : null}

            {openPayModal == true && <PayModal_Retail openModal={ openPayModal } closeModal={(event) => confirmCheckout(event)} payCloseModal={(event) => setOpenPayModal(event)} data={{
                    status: props.data.status,
                    companyId: props.data.companyId,
                    companyPhoneNumber: props.data.companyPhoneNumber,
                    mtnCompanyPhoneNumber: props.data.mtnCompanyPhoneNumber,
                    cartList: cartList,
                    firstName: enterFirstName, 
                    lastName: enterLastName,
                    mobileNumber: mobileNumber,
                    payeeMessage: 'Retail Booking Payment',
                    cartSubtotal: cartSubtotal,
                    cartCheckoutTotal: cartCheckoutTotal,
                    paymentType: checkInNonMemberPaymentType,
                    payment_amount: enterMM_nonMember_amountRef.current.value,
                    cartLatitude: cartLatitude,
                    cartLongitude: cartLongitude,
                    storefront: storefront,
                    }}></PayModal_Retail>}


    </React.Fragment>)
}